import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  const displayCategories = categories.slice(0, 6);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-black text-foreground-50">
            分类浏览
          </h2>
          <p className="mt-3 text-sm text-foreground-500">
            多种题材分类，总有一款适合你
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          <Link
            to="/category/rexue"
            className="group relative aspect-square rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20genre%20illustration%2C%20dark%20moody%20atmosphere%2C%20dramatic%20lighting%2C%20dynamic%20fight%20scene%2C%20no%20text%2C%20professional%20digital%20art&width=600&height=600&seq=category-rexue&orientation=squarish"
              alt="热血"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
              <h3 className="text-xl md:text-2xl font-heading font-black text-foreground-50">热血</h3>
              <p className="mt-1 text-xs text-foreground-300">1,280 部作品</p>
            </div>
          </Link>
          <Link
            to="/category/aiqing"
            className="group relative aspect-square rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20genre%20illustration%2C%20dark%20moody%20atmosphere%2C%20soft%20romantic%20lighting%2C%20couple%20silhouette%2C%20no%20text%2C%20professional%20digital%20art&width=600&height=600&seq=category-aiqing&orientation=squarish"
              alt="爱情"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
              <h3 className="text-xl md:text-2xl font-heading font-black text-foreground-50">爱情</h3>
              <p className="mt-1 text-xs text-foreground-300">1,560 部作品</p>
            </div>
          </Link>
          <Link
            to="/category/xuanyi"
            className="group relative aspect-square rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20genre%20illustration%2C%20dark%20moody%20atmosphere%2C%20mysterious%20lighting%2C%20noir%20detective%20vibe%2C%20no%20text%2C%20professional%20digital%20art&width=600&height=600&seq=category-xuanyi&orientation=squarish"
              alt="悬疑"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
              <h3 className="text-xl md:text-2xl font-heading font-black text-foreground-50">悬疑</h3>
              <p className="mt-1 text-xs text-foreground-300">890 部作品</p>
            </div>
          </Link>
          <Link
            to="/category/qihuan"
            className="group relative aspect-square rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20genre%20illustration%2C%20dark%20moody%20atmosphere%2C%20magical%20glowing%20elements%2C%20epic%20fantasy%20world%2C%20no%20text%2C%20professional%20digital%20art&width=600&height=600&seq=category-qihuan&orientation=squarish"
              alt="奇幻"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
              <h3 className="text-xl md:text-2xl font-heading font-black text-foreground-50">奇幻</h3>
              <p className="mt-1 text-xs text-foreground-300">2,100 部作品</p>
            </div>
          </Link>
          <Link
            to="/category/xiaoyuan"
            className="group relative aspect-square rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20school%20life%20genre%20illustration%2C%20dark%20moody%20atmosphere%2C%20classroom%20scene%2C%20youthful%20energy%2C%20no%20text%2C%20professional%20digital%20art&width=600&height=600&seq=category-xiaoyuan&orientation=squarish"
              alt="校园"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
              <h3 className="text-xl md:text-2xl font-heading font-black text-foreground-50">校园</h3>
              <p className="mt-1 text-xs text-foreground-300">760 部作品</p>
            </div>
          </Link>
          <Link
            to="/category/danmei"
            className="group relative aspect-square rounded-lg overflow-hidden cursor-pointer"
          >
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20BL%20genre%20illustration%2C%20dark%20moody%20atmosphere%2C%20elegant%20beautiful%20male%20characters%2C%20ethereal%20lighting%2C%20no%20text%2C%20professional%20digital%20art&width=600&height=600&seq=category-danmei&orientation=squarish"
              alt="耽美"
              className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
            <div className="absolute inset-0 flex flex-col items-center justify-center p-4">
              <h3 className="text-xl md:text-2xl font-heading font-black text-foreground-50">耽美</h3>
              <p className="mt-1 text-xs text-foreground-300">1,340 部作品</p>
            </div>
          </Link>
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/rexue"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-200/40 text-foreground-200 text-sm hover:bg-background-200/60 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}